import { Input } from '@design-systems/canvas-ui'
import { useEffect, useState } from 'react'

const RadioButtonGroup = (props) => {
  const [selectedOption, setSelectedOption] = useState(null)

  useEffect(() => {
    setSelectedOption(props.value)
  }, [props.value])

  /**
   * Build option view
   * @returns
   */
  const buildOptionsView = () => {
    let allOptions = []
    props.options.forEach((option, optionIndex) => {
      allOptions.push(
        <div
          className="row-centre hc8-mr-4x"
          key={`rbg-option-wrap-${optionIndex}`}
        >
          <input
            id={`rbg-option-${optionIndex}`}
            data-testid={`rbg-option-${optionIndex}`}
            type="radio"
            className="hc8-fs-100"
            value={option}
            data-label={props.id}
            checked={selectedOption === option}
            disabled={props.isReadOnly}
            onChange={(event) => {
              props.onOptionSelect(event.target.value)
            }}
          />
          <Input.Label className="hc8-fs-100 hc8-ml-2x font-weight-400">
            {option}
          </Input.Label>
        </div>,
      )
    })
    return (
      <div
        data-testid="rgb-div"
        className={
          props.options.length < 3
            ? 'row-centre hc8-mt-3x'
            : 'row-vertical hc8-mt-3x'
        }
      >
        {allOptions}
      </div>
    )
  }

  return <div className="hc8-pb-3x">{buildOptionsView()}</div>
}

export default RadioButtonGroup
